import { TitleSection } from "../title-section";

export const ModeloQuestaoEnem = () => {
  return (
    <section
      id="modelo-questao-enem"
      className="py-10 px-4 flex justify-center bg-white"
    >
      <div className="w-50 max-w-4xl">
        <TitleSection blueToRed first_title="Modelo de questão ENEM" />

        <div className="rounded-md p-4 shadow-md">
          <img
            src={require("../../assets/model-image.png")}
            alt="Modelo de Questão ENEM"
            className="w-full h-auto rounded"
          />
          <p className="text-xs text-black mt-2 font-semibold">
            Prova do Enem, 2024 —{" "}
            <span className="underline">Caderno AZUL</span>, 1º dia de
            aplicação.
          </p>
        </div>
      </div>
    </section>
  );
};
